jQuery(function($) {
	$('.recipe-servings-plus, .recipe-servings-minus').on('click', function(e) {
		$('.ingredient-quantity').each(function(i, ingredient) {
			servings = parseFloat($('.servings-amount').html());
			var amount = parseFloat($(ingredient).data('ingredient-quantity')) / servings;
			var ingredientAmount = "";
			if ($(e.target).hasClass('recipe-servings-plus')) {
				ingredientAmount = amount * (servings+1);
				setIngredientData(ingredient, ingredientAmount);
			} else if(servings > 1) {
				ingredientAmount = amount * (servings-1);
				setIngredientData(ingredient, ingredientAmount);
			}
		});
		if ($(e.target).hasClass('recipe-servings-plus')) {
			$('.servings-amount').html(servings + 1);
		} else if(servings > 1) {
			$('.servings-amount').html(servings - 1);
		}
	});
	function setIngredientData(ingredient, amount) {
		$(ingredient).html(round(amount));
		$(ingredient).data('ingredient-quantity', amount);
	}
	function round(num) {
	    return Math.round(num*4)/4;
	}
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/single-recipes.js
// module id = 33
// module chunks = 0